import Button from "../Button";
import {useNavigate} from "react-router-dom";
import {Server, User} from "../../api/types";
import {useEffect, useMemo, useState} from "react";
import {agent} from "../../api/agent";
import Table, {TableColumn} from "../table/Table";
import styled from "styled-components";
import LoadingContainer from "../LoadingContainer";

const Center = styled.div`
    display: flex;
    justify-content: center;
`;

const Container = styled.div`
    background-color: var(--content-box-bg);
    margin-top: 1rem;
    padding: 1rem;
    min-width: 40rem;
`;

export default function UserList() {

    const navigate = useNavigate();
    const [users, setUsers] = useState<User[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        setLoading(true);
        agent.getUsers().then(value => {
            setLoading(false);
            setUsers(value);
        });
    }, []);

    const columns: TableColumn[] = [
        {
            key: 'username',
            label: 'Username',
        },
        {
            key: 'permissions',
            label: 'Permissions',
            render: (_, row) => {
                if (row.superAdmin) {
                    return <span style={{color: 'red'}}>Super Admin</span>;
                }
                return <span>{row.permissions.length} Permissions</span>;
            }
        },
        {
            key: 'edit',
            label: 'Edit',
            render: (_, row) => {
                return <div onClick={() => {navigate(`/users?user=${row.id}`)}} style={{cursor: 'pointer'}}><i className="fa-solid fa-pen"></i></div>;
            }
        }
    ];

    const data = useMemo(() => {
        if (!users) return [];
        return users;
    }, [users]);

    return (
        <Center>
            <LoadingContainer open={loading}>
                <Container>
                    <Button className={'primary'} onClick={() => {navigate('/users?user=new');}}><i className="fa-solid fa-plus"></i></Button>
                    <h2>User List</h2>
                    <Table columns={columns} data={data}></Table>
                </Container>
            </LoadingContainer>
        </Center>
    );
}